export const getOrigin = () => {
    if ((globalThis as any)?.Twilio?.Flex) {
        return "flexui";
    }
    if ((globalThis as any)?.__TWILIO_FLEX_SDK__?.appType === "flex-mobile") {
        return "mobile";
    }
    return "headless";
};
